import { UUID } from "foundation-ts/types";

import { NewPersonFormValues } from "@components/ContactForm/ContactForm";
import { ContactDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";

export const STATUS = {
    ok: {
        label: "OK",
        subLabel: null,
        color: "green.400",
    },
    warning: {
        label: "Avertissement",
        subLabel: "Conflit avec un contact ou collaborateur existant",
        color: "orange.400",
    },
    excluded: {
        label: "Exclu",
        subLabel: null,
        color: "red.200",
    },
    importing: {
        label: "Importation en cours",
        subLabel: null,
        color: "gray.100",
    },
    imported: {
        label: "Importé",
        subLabel: null,
        color: "green.400",
    },
    failed: {
        label: "Echec",
        subLabel: "L'importation a échoué",
        color: "red.200",
    }
};

export type ImportContactStatus = keyof typeof STATUS;
export type ImportViewPhase = "preview" | "importing" | "done";

export interface ContactToImport {
    id: UUID;
    data: NewPersonFormValues;
    status: ImportContactStatus;
    note?: string;
    existedContact?: ContactDto;
};